import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Immutable from 'immutable';
import classNames from 'classnames';
import { Icon } from '../../icon/icon';

import styles from './product_compare_icon.css';

class ProductCompareIcon extends Component {

    /**
     * Generates an Icon with active or disabled UIComponent styles depending on an isActive param
     * @param {Boolean} isActive - is the icon active or not
     * @returns {Node} an icon component with styles
     */
    generateIcon = (isActive) => {
        const { visualProps } = this.props;
        const UIComponent = isActive ? `${visualProps.UIComponent}_active` : `${visualProps.UIComponent}_disabled`;
        const props = { ...visualProps, UIComponent };
        return <Icon {...props} />;
    };

    /**
     * Generates a div with badge styles and the number of selected products
     * @param {Number} number - the number of selected products
     * @returns {Node} a styled div with the number of selected products
     */
    generateBadge = (number) => {
        return <div className={styles.badge}>{number}</div>;
    };

    /**
     * Checks whether the number of selected products is equal or greater than the minimum number of products allowed for comparing
     * @returns {boolean} selected products are greater or equal to min products
     */
    isCompareAvailable = () => {
        const { selectedProductIds, minProducts } = this.props;
        return selectedProductIds.size >= minProducts;
    };

    render = () => {
        const { selectedProductIds, toggleCompare } = this.props;
        const isActive = this.isCompareAvailable();

        return (
            <div className={classNames({ [styles.root]: true })}>
                <a
                    className={styles.button}
                    role="button"
                    tabIndex={0}
                    onClick={isActive ? () => toggleCompare(isActive) : null}
                >
                    { selectedProductIds.size > 0 && this.generateBadge(selectedProductIds.size) }
                    { this.generateIcon(isActive) }
                    <div className={styles.label}>Compare</div>
                </a>
            </div>
        );
    };

}

ProductCompareIcon.propTypes = {
    visualProps: PropTypes.object.isRequired,
    selectedProductIds: PropTypes.instanceOf(Immutable.List),
    minProducts: PropTypes.number.isRequired,
    toggleCompare: PropTypes.func.isRequired
};

export { ProductCompareIcon };
